
<template>

  <div style="width: 100%; height: 100%;">
    <div class="inventory-header">
      {{product.title}} Inventory #{{item.id}}
    </div>
    <div class="inventory-body">
      <div style="width: 500px;">
        <div class="inventory-item-container">
          <div class="container">
            <div class="row" style="margin-top: 20px;">
              <div class="col-6">
                Current Stock
                <div class="inventory-medium">
                  <span v-if="item.weightBalance > 0">{{item.weightBalanceFloat}}Kg<br/>{{item.balance}} Fillets</span>
                  <span v-else>{{item.balance}}</span>
                </div>
              </div>
              <div class="col-6">
                Stocked In
                <div class="inventory-medium">
                  <span v-if="item.weight > 0">{{item.weightFloat}} KG<br/>{{item.originalBalance}} Fillets</span>
                  <span v-else>{{item.originalBalance}}</span>
                </div>
                at {{getTimeString(item.stockInTime)}}
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                <span >Purchased from:</span>
                <span class=" inventory-small">{{item.vendorTitle}}</span>
              </div>
            </div>
            <div class="row">
              <div class="col-12 inventory-large" style="line-height: 50px; margin-top: 10px;">
                <span class="inventory-small"  style="line-height: 50px;">Location</span>
                <span>{{item.area}} - {{item.location}} - {{item.section}}</span>
              </div>
            </div>
            <div class="row">
              <div class="col-12 inventory-small">
                Batch Code <span class="inventory-medium">{{item.batchCode}}</span>
              </div>
              <div class="col-12 inventory-small" v-if="item.expiryDate !== null && item.expiryDate.length > 0">
                Expiry <span class="inventory-medium">{{dateText(item.expiryDate)}}</span>
              </div>
            </div>
            <div class="row">
              <div class="col-4">
                Selling Price
                <div class="inventory-medium">
                  <span v-if="item.sellingPrice > 0">
                  £{{item.sellingPriceFloat.toFixed(2)}}
                  </span>
                  <span v-else style="color: red;">£{{product.priceFloat.toFixed(2)}}</span>
                </div>
                <div v-if="item.sellingPrice === 0">
                  Product Price
                  <div class="inventory-medium">£{{product.priceFloat.toFixed(2)}}</div>
                </div>
              </div>
              <div class="col-4">
                <span v-if="product.useVariablePrice === true">Price per KG</span><span v-else>Unit Prime Cost</span>
                <div class="inventory-medium">
                  <span v-if="product.useVariablePrice === true">£{{item.pricePerWeightFloat.toFixed(2)}}</span>
                  <span v-else>£{{item.unitPriceFloat.toFixed(2)}}</span>
                </div>
              </div>
              <div class="col-4">
                Total Prime Value
                <div class="inventory-medium">£{{item.valueFloat.toFixed(2)}}</div>
              </div>
            </div>

          </div>

        </div>
        <div class="container">
          <div class="row">

            <div class="col-4">
              <button class="btn btn-success form-control" @click="openChangeLocationForm">Change Location</button>
            </div>
            <div class="col-4">
              <button class="btn btn-primary form-control" @click="openOutForm">Out Stock</button>
            </div>
            <div class="col-4">
              <button class="btn btn-success form-control" @click="openMoveForm">Partial Move</button>
            </div>
          </div>
          <div class="row" style="margin-top: 20px;">
            <div class="col-4">
              <button class="btn btn-danger form-control" @click="openCorrectionForm">Correction</button>
            </div>
            <div class="col-4">
            </div>
            <div class="col-4">
              <button class="btn btn-primary form-control" @click="openPriceForm">Selling Price</button>
            </div>
          </div>

          <div class="row" style="margin-top: 20px" v-if="item.active === true">
            <div class="col-4">
              <button class="btn btn-danger form-control" @click="deactivate">Mark as inactive</button>
            </div>
            <div class="col-4"></div>
            <div class="col-4">
              <button class="btn btn-primary form-control" @click="openPrimeCostForm">Prime Cost</button>
            </div>
          </div>
          <div class="row" style="margin-top: 20px" v-if="item.active === false">
            <div class="col-4">
              <button class="btn btn-danger form-control" @click="activate">ACTIVATE</button>
            </div>

          </div>
          <div class="row" style="margin-top: 50px;">
            <div class="col-4">
              <button class="btn btn-dark form-control" @click="onClose">CLOSE</button>
            </div>
            <div class="col-4">

            </div>
            <div class="col-4">
              <button class="btn btn-success" style="float:right; margin-right:10px;" v-on:click="getHistory('Inventory History', 'Inventory Number ' + item.id, 'inventoryId='+ item.id)"><i class="fas fa-history"></i> History</button>
            </div>
          </div>
        </div>
      </div>
      <div style="width: calc(100% - 500px); overflow-y: auto;">

        <table class="table">
          <tr>
            <!--                <th>#</th>-->
            <th>Type</th>
            <th>처리일</th>
            <th>Date</th>
            <th></th>
            <th>Prev Balance</th>
            <th>Qty</th>
            <th>Balance</th>
            <th>Inventory Balance</th>
            <th v-if="product.useVariablePrice === true">Prev Weight</th>
            <th v-if="product.useVariablePrice === true">KG</th>
            <th v-if="product.useVariablePrice === true">Balance Weight</th>
            <th>Order#</th>
            <th>Order Item#</th>
            <th>Inventory</th>
            <th>PO#</th>
            <th>Net</th>
            <th>Vat</th>
            <th>Gross</th>
            <th class="text-left">Shop</th>
            <th>Vendor</th>
            <th>By</th>
            <th></th>
            <th>Unit Value</th>
            <th>Value</th>

          </tr>
          <tr v-for="s in stocks">
            <!--                <td>{{s.id}}</td>-->
            <td v-html="getStockIcon(s)"></td>
            <td>{{getTimeString(s.createdTimestamp)}}</td>
            <td>{{s.stockDate}}</td>
            <td><span v-if="s.documents.length > 0" style="padding-left: 10px; padding-right: 10px;"><a :href="s.documents[0]" target="_blank"><i class="fas fa-file"></i></a></span></td>
            <td>{{s.previousBalance}}</td>
            <td>{{s.diff}}</td>
            <td>{{s.balance}}</td>
            <td>{{s.inventoryItemBalance}}</td>
            <td v-if="product.useVariablePrice === true">
              {{(s.previousBalanceWeight/100.0).toFixed(2)}} Kg
            </td>
            <td v-if="product.useVariablePrice === true">
                    {{(s.diffWeight/100.0).toFixed(2)}} Kg
            </td>
            <td v-if="product.useVariablePrice === true">
                    {{(s.balanceWeight/100.0).toFixed(2)}} Kg
            </td>

            <td>
              <span v-if="s.invoice != null">{{s.invoice.title}}</span>

              <span v-else-if="s.orderId > 0" style="text-decoration: underline;"
                    v-on:click="getHistory('Order History', 'Order Number ' + s.orderId, 'orderId='+ s.orderId)">{{s.orderId}}</span>
              <span v-else-if="s.creditOrderId > 0">CR{{s.creditOrderId}}</span>
            </td>
            <td>
              <span style="text-decoration: underline;"
              v-on:click="getHistory('Order Item History', 'Order Item Number ' + s.orderItemId, 'orderItemId='+ s.orderItemId)"
              >
                {{s.orderItemId}}
              </span>
            </td>
            <td>
              {{s.inventoryId}}
            </td>
            <td><span v-if="s.vendorOrderId > 0">{{s.vendorOrderId}}</span></td>
            <td><span v-if="s.totalPrice != 0">{{(s.totalPrice/100.0).toFixed(2)}}</span></td>
            <td><span>{{(s.taxRate/100.0).toFixed(0)}}%</span><span v-if="s.tax != 0">{{(s.tax/100.0).toFixed(2)}}</span></td>
            <td><span v-if="s.finalDue != 0">{{(s.finalDue/100.0).toFixed(2)}}</span></td>
            <td class="text-left">{{getMerchantName(s.merchantId)}}</td>
            <td><span v-if="s.vendorId > 0">{{getVendorName(s.vendorId)}}</span></td>
            <td>{{s.userName}}</td>
            <td><span v-on:click="editStock(s)"><i class="fas fa-edit"></i></span></td>
            <td>{{(s.unitValue/100.0).toFixed(2)}}</td>
            <td>

                  {{(s.value/100.0).toFixed(2)}}

            </td>
          </tr>
        </table>
      </div>


    </div>
    <div class="inventory-footer">

    </div>
    <div v-if="correctionForm !== false" style="position: fixed; top:0; left: 0; right: 0; width: 100%; height: 100%; background: rgba(0,0,0,0.6); z-index: 4;" @click="closeCorrectionForm">
      <div style="position: absolute; top: 50%; left: 50%; background: white; width: 500px; transform: translate(-50%, -50%); padding: 50px; max-height: 70%;" @click.stop="dummy">
        <div class="container">
          <div class="row">
            <div class="col-12" style="font-weight: bold; font-size: 20px;">
              Inventory Balance Correction
            </div>
          </div>
          <div class="row" style="padding-top: 50px;">
            <div class="col-4">
              Current
            </div>
            <div class="col-4">

            </div>
            <div class="col-4">
              New
            </div>
          </div>
          <div class="row">
            <div class="col-4">
              <label class="form-control">{{correctionForm.currentBalance}}</label>
            </div>
            <div class="col-4">
              <span><i class="fas fa-arrow-right"></i></span>
            </div>
            <div class="col-4">
              <input class="form-control" type="number" v-model="correctionForm.newBalance"/>
            </div>
          </div>
          <div class="row" v-if="product.useVariablePrice === true">
            <div class="col-4">
              <label class="form-control">{{(correctionForm.currentWeight/100.0).toFixed(2)}}</label>
            </div>
            <div class="col-4">
              <span><i class="fas fa-arrow-right"></i></span>
            </div>
            <div class="col-4">
              <input class="form-control" type="number" v-model="correctionForm.newWeightFloat"/>
            </div>
          </div>
          <div class="row text-left">
            <div class="col-12">
              Description
              <textarea v-model="correctionForm.description" rows="3" class="form-control"/>
            </div>
          </div>
          <div class="row" style="padding-top: 50px;">
            <div class="col-6">
              <button class="btn btn-dark form-control" @click="closeCorrectionForm">Close</button>
            </div>
            <div class="col-6">
              <button class="btn btn-primary form-control" @click="submitCorrection">Change</button>
            </div>
          </div>
        </div>
      </div>

    </div>
    <div v-if="outForm !== false" style="position: fixed; top:0; left: 0; right: 0; width: 100%; height: 100%; background: rgba(0,0,0,0.6); z-index: 4;" @click="closeOutForm">
      <div style="position: absolute; top: 50%; left: 50%; background: white; width: 500px; transform: translate(-50%, -50%); padding: 50px; max-height: 90%; overflow-y: auto;" @click.stop="dummy">
        <div class="container">
          <div class="row">
            <div class="col-12" style="font-weight: bold; font-size: 20px;">
              Stock out
            </div>
          </div>

          <div class="row" style="padding-top: 50px;" >
            <div class="col-6">
              Current
            </div>

            <div class="col-6">
              <span v-if="product.useVariablePrice  === true">
                KG
              </span>
              <span v-else>Quantity </span>
              to out
            </div>
          </div>
          <div class="row"  v-if="product.useVariablePrice  === true">
            <div class="col-6">
              <label class="form-control">{{item.weightBalanceFloat.toFixed(2)}} kg</label>
            </div>

            <div class="col-6">
              <input class="form-control" type="number" v-model="outForm.stock.diffWeightFloat"/>
            </div>
          </div>
          <div class="row"  v-else>
            <div class="col-6">
              <label class="form-control">{{item.balance}}</label>
            </div>

            <div class="col-6">
              <input class="form-control" type="number" v-model="outForm.stock.diff"/>
            </div>
          </div>
          <div class="row">
            <div class="col-4">
              Stock Out Type
            </div>
            <div class="col-8">
              <select v-model="outForm.stock.type" class="form-control">
                <option>Select</option>
<!--                <option value="return">Return</option>-->
                <option value="return_to_vendor">Return to Vendor</option>
                <option value="return_cancel">Return Cancel</option>
<!--                <option value="disposal">Disposal</option>-->
                <option value="damaged">Damaged</option>
                <option value="in_house_disposal">In House Disposal</option>
                <option value="3rd_disposal">3rd Party Disposal</option>
                <option value="cancel_order">Cancel Order</option>
                <option value="sample">Sample</option>
                <option value="donation">Donation</option>
                <option value="internal_use">Internal Use</option>
                <option value="others">Others</option>
              </select>
            </div>
          </div>

          <div class="row text-left">
            <div class="col-12">
              Description
              <textarea v-model="outForm.stock.description" rows="3" class="form-control"/>
            </div>
          </div>
          <div class="row text-left">
            <div class="col-12">
              Images
              <div class="image-list-container" v-if="outForm.stock.documents.length > 0">
                <div class="image-item" v-if="outForm.stock.documents.length > 0" v-for="(img, index) in outForm.stock.documents" v-bind:style="{ backgroundImage: 'url(' + img +')'}">
                  <i class="fas fa-trash top-left-icon" v-on:click="outForm.stock.documents.splice(index, 1);"></i>
                </div>


              </div>
              <div class="image-control">
                <progress value="0" max="100" id="uploader"></progress>
                <br>
                <input accept="image/*" type="file" ref="file" value="upload" @change="fileBtn"/>
              </div>
            </div>

          </div>
          <div class="row" style="padding-top: 50px;">
            <div class="col-6">
              <button class="btn btn-dark form-control" @click="closeOutForm">Close</button>
            </div>
            <div class="col-6">
              <button class="btn btn-primary form-control" @click="submitOutForm">OUT</button>
            </div>
          </div>
        </div>
      </div>

    </div>


    <div v-if="changeLocationForm !== false" style="position: fixed; top:0; left: 0; right: 0; width: 100%; height: 100%; background: rgba(0,0,0,0.6); z-index: 4;" @click="closeChangeLocationForm">
      <div style="position: absolute; top: 50%; left: 50%; background: white; width: 500px; transform: translate(-50%, -50%); padding: 50px; max-height: 70%;" @click.stop="dummy">
        <div class="container">
          <div class="row">
            <div class="col-12" style="font-weight: bold; font-size: 20px;">
              Change Location
            </div>
          </div>
          <div class="row" style="padding-top: 50px;">
            <div class="col-12">
              Current Location
            </div>

            <div class="col-4">
              Area
              <label class="form-control">{{item.area}}</label>
            </div>
            <div class="col-4">
              Location
              <label class="form-control">{{item.location}}</label>
            </div>
            <div class="col-4">
              Section
              <label class="form-control">{{item.section}}</label>
            </div>
          </div>
          <div class="row" style="padding-top: 50px;">
            <div class="col-12">
              New Location
            </div>
            <div class="col-4">
              Area

              <select v-model="changeLocationForm.area" class="form-control">
                <option value="">Select</option>
                <option v-for="a in areas" :value="a">{{a}}</option>
              </select>
            </div>
            <div class="col-4">
              Location
              <select v-model="changeLocationForm.location" class="form-control">
                <option value="">Select</option>
                <option v-for="a in locations" :value="a">{{a}}</option>
              </select>
            </div>
            <div class="col-4">
              Section
              <select v-model="changeLocationForm.section" class="form-control">
                <option value="">Select</option>
                <option v-for="a in sections" :value="a">{{a}}</option>
              </select>
            </div>
          </div>

          <div class="row" style="padding-top: 50px;">
            <div class="col-6">
              <button class="btn btn-dark form-control" @click="closeChangeLocationForm">Close</button>
            </div>
            <div class="col-6">
              <button class="btn btn-primary form-control" @click="submitChangeLocationForm">CHANGE</button>
            </div>
          </div>
        </div>
      </div>

    </div>

    <div v-if="editForm !== false" style="position: fixed; top:0; left: 0; right: 0; width: 100%; height: 100%; background: rgba(0,0,0,0.6); z-index: 4;" @click="closeMoveForm">
      <div style="position: absolute; top: 50%; left: 50%; background: white; width: 500px; transform: translate(-50%, -50%); padding: 20px; max-height: 70%; border-radius: 20px;" @click.stop="dummy">
        <div class="container">
          <div class="row">
            <div class="col-12" style="font-weight: bold; font-size: 20px;">
              Edit Inventory
            </div>
          </div>
          <template v-if="product.useVariablePrice === true">
            <div class="row">
              <div class="col-12">
                Total In Weight
              </div>
              <div class="col-6">
                Original In
                <br/>
                {{item.weightFloat.toFixed(2)}}
              </div>
              <div class="col-6">

                <input class="form-control" v-model="editForm.weightFloat" @change="onEditValueChanged"></input>
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                Current Stock Weight
              </div>
              <div class="col-6">
                Current
                <br/>
                {{item.weightBalance.toFixed(2)}}
              </div>
              <div class="col-6">
                New
                <input class="form-control" v-model="editForm.weightBalanceFloat"></input>
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                Price per Kg
              </div>
              <div class="col-6">
                Old
                <div>{{item.pricePerWeightFloat.toFixed(2)}}</div>
              </div>
              <div class="col-6">
                New
                <input class="form-control" v-model="editForm.pricePerWeightFloat" @change="onEditValueChanged"></input>
              </div>
            </div>
          </template>
          <template class="row" v-else>
            <div class="row">
              <div class="col-12">
                In Quantity
              </div>
              <div class="col-6">
                Current
                <br/>
                {{item.originalBalance}}
              </div>
              <div class="col-6">
                New
                <input class="form-control" v-model="editForm.quantity" @change="onEditValueChanged"></input>
              </div>
            </div>
            <div class="row">
              <div class="col-12">
                Unit Price
              </div>
              <div class="col-6">
                Current
                <br/>
                {{item.unitPriceFloat}}
              </div>
              <div class="col-6">
                New
                <input class="form-control" v-model="editForm.unitPriceFloat" @change="onEditValueChanged"></input>
              </div>
            </div>

          </template>
          <div class="row">

            <div class="col-4">
              NET
              <br/>{{(editForm.net/100.0).toFixed(2)}}
            </div>
            <div class="col-4">
              VAT
              <br/>{{(editForm.vat/100.0).toFixed(2)}}
            </div>
            <div class="col-4">
              GROSS
              <br/>{{(editForm.gross/100.0).toFixed(2)}}
            </div>

          </div>
        </div>
        <div class="container">
          <div class="row">
            <div class="col-6">
              <button class="btn btn-dark form-control" @click="closeEditForm">CLOSE</button>
            </div>
            <div class="col-6">
              <button class="btn btn-primary form-control" @click="submitEditForm">SUBMIT</button>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-if="priceForm !== false"  style="position: fixed; top:0; left: 0; right: 0; width: 100%; height: 100%; background: rgba(0,0,0,0.6); z-index: 4;" @click="closePriceForm">
      <div style="position: absolute; top: 50%; left: 50%; background: white; width: 500px; transform: translate(-50%, -50%); padding: 20px; max-height: 70%; border-radius: 20px;" @click.stop="dummy">
        <div class="container">
          <div class="row">
            <div class="col-12" style="font-weight: bold; font-size: 20px;">
              Change Selling Price
            </div>
          </div>
          <div class="row" style="padding-top: 20px;">
            <div class="col-12" style="font-size: 18px;">
              Unit Purchasing Price is £{{item.unitPriceFloat.toFixed(2)}}
            </div>
          </div>
          <div class="row" style="padding-top: 20px;">
            <div class="col-6" style="font-size: 20px;">
              Current Price
              <br/>
              <span class="inventory-large" style="line-height: 90px;">{{item.sellingPriceFloat.toFixed(2)}}</span>
            </div>
            <div class="col-6">
              <span  style="font-size: 20px;">New Price</span>
              <input class="form-control" style="font-size: 50px; text-align: center; font-weight: bold;" v-model="priceForm.priceFloat" @keyup="onPriceFormChanged"/>
            </div>
          </div>
          <div class="row" style="padding-top: 20px;">
            <div class="col-12" style="font-size: 20px;">
              <span v-if="item.unitPrice > priceForm.sellingPrice" style="color:#e7344c; font-weight: bold;">* Selling price is lower than purchasing price!!!</span>
            </div>
          </div>
          <div class="row" style="padding-top: 20px; border-top: 1px solid #ccc; margin-top: 40px;">
            <div class="col-6">
              <button class="btn btn-dark form-control" @click="closePriceForm">Close</button>
            </div>
            <div class="col-6">
              <button class="btn btn-primary form-control" @click="submitPriceForm">SUBMIT</button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="primeCostForm !== false"  style="position: fixed; top:0; left: 0; right: 0; width: 100%; height: 100%; background: rgba(0,0,0,0.6); z-index: 4;" @click="closePrimeCostForm">
      <div style="position: absolute; top: 50%; left: 50%; background: white; width: 500px; transform: translate(-50%, -50%); padding: 20px; max-height: 70%; border-radius: 20px;" @click.stop="dummy">
        <div class="container">
          <div class="row">
            <div class="col-12" style="font-weight: bold; font-size: 20px;">
              Change Prime Cost
            </div>
          </div>

          <div class="row" style="padding-top: 20px;">
            <div class="col-6" style="font-size: 20px;">
              Current Prime Cost
              <br/>

              <span v-if="product.useVariablePrice === false" class="inventory-large" style="line-height: 90px;">{{item.unitPriceFloat.toFixed(2)}}</span>
              <span v-else-if="product.useVariablePrice === true" class="inventory-large" style="line-height: 90px;">{{item.pricePerWeightFloat.toFixed(2)}}</span>
            </div>
            <div class="col-6">
              <span  style="font-size: 20px;">New Prime Cost</span>
              <input class="form-control" style="font-size: 50px; text-align: center; font-weight: bold;" v-model="primeCostForm.unitPriceFloat"/>
            </div>
          </div>
<!--          <div class="row" style="padding-top: 20px;">-->
<!--            <div class="col-12" style="font-size: 20px;">-->
<!--              <span v-if="item.unitPrice > priceForm.sellingPrice" style="color:#e7344c; font-weight: bold;">* Selling price is lower than purchasing price!!!</span>-->
<!--            </div>-->
<!--          </div>-->
          <div class="row" style="padding-top: 20px; border-top: 1px solid #ccc; margin-top: 40px;">
            <div class="col-6">
              <button class="btn btn-dark form-control" @click="closePrimeCostForm">Close</button>
            </div>
            <div class="col-6">
              <button class="btn btn-primary form-control" @click="submitPrimeCostForm">SUBMIT</button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-if="moveForm !== false" style="position: fixed; top:0; left: 0; right: 0; width: 100%; height: 100%; background: rgba(0,0,0,0.6); z-index: 4;" @click="closeMoveForm">
      <div style="position: absolute; top: 50%; left: 50%; background: white; width: 500px; transform: translate(-50%, -50%); padding: 20px; max-height: 70%; border-radius: 20px; overflow-y: scroll;" @click.stop="dummy">
        <div class="container">
          <div class="row">
            <div class="col-12" style="font-weight: bold; font-size: 20px;">
              Move Stocks
            </div>
          </div>
          <div class="row" style="padding-top: 20px;" v-if="product.useVariablePrice === true">
            <div class="col-6">
              Current Stock <br/><span class="inventory-large">{{item.weightBalanceFloat}}kg</span>
            </div>
            <div class="col-6 text-left">
              Current Location <br/><span class="inventory-medium">{{item.area}} - {{item.location}} - {{item.section}}</span>
            </div>

          </div>
          <div class="row" style="padding-top: 20px;" v-else>
            <div class="col-6">
              Current Stock <br/><span class="inventory-large">{{item.balance}}</span>
            </div>
            <div class="col-6 text-left">
              Current Location <br/><span class="inventory-medium">{{item.area}} - {{item.location}} - {{item.section}}</span>
            </div>

          </div>
          <div class="row" style="padding-top: 20px;"  v-if="product.useVariablePrice === true">
            <div class="col-6 text-left" style="line-height: 40px;">
              <b>How many KG to move</b> (up to {{item.weightBalanceFloat -1}}kg)
            </div>
            <div class="col-6">
              <input class="form-control text-center" v-model="moveForm.newWeightFloat" style="height: 40px; line-height: 40px; font-size: 30px;"/>
            </div>
          </div>
          <div class="row" style="padding-top: 20px;">
            <div class="col-6 text-left" style="line-height: 40px;">
              <b>How many <span v-if="product.useVariablePrice === true">Fillets </span>to move</b> (up to {{item.balance -1}})
            </div>
            <div class="col-6">
              <input class="form-control text-center" v-model="moveForm.newBalance" style="height: 40px; line-height: 40px; font-size: 30px;"/>
            </div>
          </div>
          <div class="row" style="padding-top: 20px;">
            <div class="col-12 text-left">
              <b>New Location</b>
            </div>
            <div class="col-4">
              Area

              <select v-model="moveForm.area" class="form-control">
                <option value="">Select</option>
                <option v-for="a in areas" :value="a">{{a}}</option>
              </select>
            </div>
            <div class="col-4">
              Location
              <select v-model="moveForm.location" class="form-control">
                <option value="">Select</option>
                <option v-for="a in locations" :value="a">{{a}}</option>
              </select>
            </div>
            <div class="col-4">
              Section
              <select v-model="moveForm.section" class="form-control">
                <option value="">Select</option>
                <option v-for="a in sections" :value="a">{{a}}</option>
              </select>
            </div>

          </div>

          <div class="row" style="padding-top: 20px;">
            <div class="col-12 text-left">
              <b>Will the new location inventory to stock out</b> before or after than original inventory?
            </div>
            <div class="col-6">
              <button class="selector-btn" :class="{'selected': moveForm.timeDiff === -1000}" @click="moveForm.timeDiff = -1000">Before</button>
            </div>
            <div class="col-6">
              <button class="selector-btn" :class="{'selected': moveForm.timeDiff === 1000}" @click="moveForm.timeDiff = 1000">After</button>
            </div>
          </div>
          <div class="row" style="padding-top: 20px; border-top: 1px solid #ccc; margin-top: 40px;">
            <div class="col-6">
              <button class="btn btn-dark form-control" @click="closeMoveForm">Close</button>
            </div>
            <div class="col-6">
              <button class="btn btn-primary form-control" @click="submitMoveForm">MOVE <span v-if="moveForm.newBalance > 0">{{moveForm.newBalance}}</span></button>
            </div>
          </div>
        </div>
      </div>

    </div>
    <transition name="slideup">
      <div v-if="selectorView !== false" style="width: 100%; height: 100%; z-index: 3; position: fixed; top: 0; left: 0; background: rgba(0,0,0,0.3);" @click="selectorView = false">
        <div style="width: 600px; max-height: 80%; position: absolute; left: 50%; top: 50%; background: white; transform: translate(-50%, -50%); padding: 20px; border-radius: 20px;">
          <div class="container">
            <div class="row">
              <div class="col-12" style="line-height: 30px; font-size: 20px;">
                {{selectorView.title}}
              </div>
              <div class="col-12" style="margin-top: 30px; font-size: 15px;" v-html="selectorView.message">

              </div>

            </div>
            <div class="row" style="margin-top: 30px;">
              <div class="col-5">
                <div class="kh-btn kh-9 form-control" style="height: 60px;" @click="selectorView.negativeButton.onClicked(false)">{{selectorView.negativeButton.title}}</div>
              </div>


              <div class="col-2">
              </div>
              <div class="col-5">
                <button class="kh-btn kh-4 form-control" style="height: 60px;" @click="selectorView.positiveButton.onClicked(true)">{{selectorView.positiveButton.title}}</button>
              </div>
            </div>
          </div>

          <div class="popup-close-btn"
               @click="selectorView = false;">
            <span ><i class="fas fa-times" style="color: black;"></i></span>

          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import {
  changeInventoryInventory, changeInventoryPrimeCost, changeInventorySellingPrice,
  correctInventory, deactivateInventory, editInventoryInventory, getAreaList,
  getInventoryStocks, getLocationList,
  getNewStock, getSectionList, moveInventoryInventory,
  stockOutFromInventory
} from "../../api/product";
import {getFilePathFromTodayDate, millisToReadable, showDialog, timeToLocaleDateShort} from "../../api/utils";
import * as firebase from "firebase";
import moment from 'moment';
import EventBus from "../../api/event-bus";

export default {
  name:'InventoryItemView',
  props:{
    item: {
      type: Object,
      default: function(){return null;}
    },
    product: {
      type: Object,
      default: function() {return null;}
    },
    merchants: {
      type: Array,
      default: function() { return []}
    },
    vendors: {
      type: Array,
      default: function() { return []}
    },
    suppliers: {
      type: Array,
      default: function() { return []}
    },
    onClose: {
      type: Function,
      default: null,
    },
    onUpdated: {
      type: Function,
      default: null,
    },
    onProductUpdated: {
      type: Function,
      default: null,
    },
    onReorder: {
      type: Function,
      default: null,
    }

  },
  data() {
    return {
      stocks: [],
      correctionForm:false,
      outForm:false,
      changeLocationForm: false,
      moveForm: false,
      editForm: false,
      priceForm: false,
      primeCostForm: false,
      areas:getAreaList(),
      locations: getLocationList(),
      sections: getSectionList(),
      selectorView: false,
    }
  },
  created() {
    this.initialise();
  },
  mounted() {
    let areaFound = false;
    for(let i = 0 ;  i < this.$data.areas.length ; i++) {
      if(this.$data.areas[i] === this.item.area) {
        areaFound = true;
        break;
      }
    }
    if(areaFound === false && this.item.area !== null && this.item.area !== '') {
      this.$data.areas.push(this.item.area);
    }

    let locationFound = false;
    for(let i = 0 ;  i < this.$data.locations.length ; i++) {
      if(this.$data.locations[i] === this.item.location) {
        locationFound = true;
        break;
      }
    }
    if(locationFound === false && this.item.location !== null && this.item.location !== '') {
      this.$data.locations.push(this.item.location);
    }

    let sectionFound = false;
    for(let i = 0 ;  i < this.$data.sections.length ; i++) {
      if(this.$data.sections[i] === this.item.section) {
        sectionFound = true;
        break;
      }
    }
    if(sectionFound === false && this.item.section !== null && this.item.section !== '') {
      this.$data.sections.push(this.item.section);
    }
  },
  beforeDestroy() {
  },
  destroyed() {
  },
  methods: {
    dummy: function() {

    },
    getHistory: function(title, message, query) {
      EventBus.$emit("getHistory", title, message, query);
    },
    closeView: function() {
      if(this.onClose !== null) {
        this.onClose();
      }
    },
    dateText: timeToLocaleDateShort,
    initialise: function() {
      this.getStockList();
    },
    getStockList: function() {

      if(this.item.id === 0) {
        return;
      }
      let self = this;
      getInventoryStocks(this.item.id)
        .then(function(data) {
          if(data.success === true) {
            self.$data.stocks = data.item;
          }
        })
        .catch(function(err) {
          console.log(err);
          if(err.response !== undefined) {
            console.log(err.response);
          }
        })
    },

    getStockIcon: function(item) {
      if(item.type === 'stock_in') {
        return '<span style="color:green;">In <i class="fas fa-arrow-left" ></i></span>';
      } else if(item.type === 'stock_out') {
        return '<span style="color:red;">Out <i class="fas fa-arrow-right" ></i></span>';
      } else if(item.type === 'stock_correction') {
        return '<span style="color:blue;">Cor <i class="fas fa-wrench" ></i></span>';
      } else if(item.type === 'cancel_order') {
        return '<span style="color:black">Cancel <i class="fas fa-times"></i></span>';
      } else if(item.type === 'return') {
        return '<span style="color:purple">Return <i class="fas fa-undo"></i></span>';
      } else if(item.type === 'return_cancel') {
        return '<span style="color:purple">Return Cancel <i class="fas fa-wrench"></i></span>';
      } else if(item.type === 'return_to_vendor') {
        return '<span style="color:red">Vendor <i class="fas fa-undo"></i></span>';
      } else if(item.type === 'in_house_disposal') {
        return '<span style="color:red;">In House Disposal <i class="fas fa-trash"></i></span>';
      } else if(item.type === '3rd_disposal') {
        return '<span style="color:red;">3rd Party Disposal <i class="fas fa-trash"></i></span>';
      } else if(item.type === 'disposal') {
        return '<span style="color:purple;">Disposal <i class="fas fa-trash"></i></span>';
      } else if(item.type === 'sample') {
        return '<span style="color:purple;">Sample <i class="fas fa-gift"></i></span>';
      } else if(item.type === 'donation') {
        return '<span style="color:purple;">Donation <i class="fas fa-gift"></i></span>';
      } else if(item.type === 'internal_use') {
        return '<span style="color:purple;">Internal Use <i class="fas fa-trash"></i></span>';
      } else if(item.type === 'damaged') {
        return '<span style="color:red;">Damaged <i class="fas fa-dizzy"></i></span>';
      } else if(item.type === 'others') {
        return '<span style="color:red;">Others <i class="fas fa-question"></i></span>';
      }
      return 'Unknown';
    },
    getMerchantName: function(id) {
      if(id == 0 || this.merchants.length == 0) {
        return ''
      }
      for(let i = 0 ; i < this.merchants.length ;i++ ) {
        if(this.merchants[i].id == id) {
          return this.merchants[i].title;
        }
      }
      return '? ' + id;
    },
    getVendorName: function(id) {
      if(id == 0) {
        return'';
      }
      if(this.vendors.length == 0) {
        return ''
      }
      for(let i = 0 ; i < this.vendors.length ;i++ ) {
        if(this.vendors[i].id == id) {
          return this.vendors[i].title;
        }
      }
      if(this.suppliers.length == 0) {
        return '';
      }
      for(let i = 0 ; i < this.suppliers.length ;i++ ) {
        if(this.suppliers[i].id == id) {
          return this.suppliers[i].title;
        }
      }
      return '? ' + id;
    },
    getTimeString:millisToReadable,
    openChangeLocationForm: function() {
      this.$data.changeLocationForm = {
        id: this.item.id,
        area:'',
        location:'',
        section:'',
      }
    },
    closeChangeLocationForm: function() {
      this.$data.changeLocationForm = false;
    },
    submitChangeLocationForm: function() {
      let form = {
        id: this.item.id,
        area: this.$data.changeLocationForm.area,
        location: this.$data.changeLocationForm.location,
        section: this.$data.changeLocationForm.section,
      };

      let self = this;
      changeInventoryInventory(form)
        .then(function(data) {
          if(data.success === true) {
            self.item.area = data.inventory.area;
            self.item.location = data.inventory.location;
            self.item.section = data.inventory.section;
            self.item.updatedTime = data.inventory.updatedTime;

            self.$data.changeLocationForm = false;
          } else {
            showDialog(data.message);
          }
        })
        .catch(function(err) {
          let msg = err;
          if(err.response !== undefined) {
            msg += ' (' + err.response + ' )';
          }
          showDialog(msg, "ERROR")
        })
    },
    openEditForm: function() {
      this.$data.editForm = {
        id:this.item.id,
        weightFloat:this.item.weightFloat,
        weight:this.item.weight,
        weightBalanceFloat: this.item.weightBalanceFloat,
        weightBalance: this.item.weightBalance,
        pricePerWeightFloat:this.item.pricePerWeightFloat,
        pricePerWeight:this.item.pricePerWeight,
        quantity:this.item.originalBalance,
        unitPriceFloat:this.item.unitPriceFloat,
        unitPrice:this.item.unitPrice,
        vatRate: this.product.vatRate,
        net:this.item.net,
        vat:this.item.vat,
        gross:this.item.gross,
      }
    },
    closeEditForm: function() {
      this.$data.editForm = false;
    },
    onEditValueChanged: function() {

      if(this.product.useVariablePrice === true) {
        this.$data.editForm.weight = Math.round(parseFloat(this.$data.editForm.weightFloat) * 100);
        this.$data.editForm.pricePerWeight = Math.round(parseFloat(this.$data.editForm.pricePerWeightFloat) * 100);

        this.$data.editForm.net = this.$data.editForm.weight * this.$data.editForm.pricePerWeight / 100;
      } else {
        this.$data.editForm.unitPrice = Math.round(parseFloat(this.$data.editForm.unitPriceFloat) * 100);
        this.$data.editForm.net = this.$data.editForm.unitPrice * this.$data.editForm.quantity;
      }
      if(this.product.vatRate > 0) {
        this.$data.editForm.vat = this.$data.editForm.net* this.$data.editForm.vatRate / 10000;
      } else {
        this.$data.editForm.vat = 0;
      }
      this.$data.editForm.gross = this.$data.editForm.net + this.$data.editForm.vat;
    },
    submitEditForm: function() {
      if(this.product.useVariablePrice === true) {
        if(this.$data.editForm.weightBalanceFloat === null || this.$data.editForm.weightBalanceFloat === '') {
          showDialog("Please enter current weight stock in kg");
          return;
        }
        this.$data.editForm.weightBalance = Math.round(parseFloat(this.$data.editForm.weightBalanceFloat)*100);
        if(this.$data.editForm.weight === 0) {
          showDialog("Please enter stocked in weight");
          return;
        }
        if(this.$data.editForm.pricePerWeight === 0) {
          showDialog("Please enter price per kg");
          return;
        }
        if(this.$data.editForm.weightBalance === 0) {
          showDialog("Please enter price per kg");
          return;
        }
      } else {
        if(this.$data.editForm.unitPrice === 0) {
          showDialog("Please enter unit price");
          return;
        }
        if(this.$data.editForm.quantity === 0) {
          showDialog("Please enter the quantity when stocked in");
          return;
        }
      }

      let self = this;
      editInventoryInventory(this.$data.editForm)
        .then(function(data){
          if(data.success === true) {
            if(data.inventories !== undefined && data.inventories !== null) {
              for(let i = 0 ; i < data.inventories.length ; i++) {
                if(self.onUpdated !== null) {
                  self.onUpdated(data.inventories[i]);
                }
              }
            }
            self.$data.editForm = false;
          } else {
            showDialog(data.message, "Failed to move");
          }
        })
        .catch(function(err) {
          let msg = err;
          if(err.response !== undefined) {
            msg += ' (' + err.response + ')';
          }
          showDialog(msg, "ERROR at moving inventory");
        })

    },
    openPrimeCostForm: function() {
      this.$data.primeCostForm = {
        id: this.item.id,
        unitPriceFloat: 0.00,
        unitPrice:0,
      }
    },
    closePrimeCostForm: function() {
      this.$data.primeCostForm = false;
    },
    submitPrimeCostForm: function() {
      if(this.$data.primeCostForm.unitPriceFloat === null || this.$data.primeCostForm.unitPriceFloat === '') {
        this.$data.primeCostForm.unitPrice = 0;
      } else {
        this.$data.primeCostForm.unitPrice = Math.round(parseFloat(this.$data.primeCostForm.unitPriceFloat) * 100);
      }

      let self = this;
      changeInventoryPrimeCost(this.$data.primeCostForm)
        .then(function(data) {
          if(data.success) {
            if(self.onUpdated !== null) {
              self.onUpdated(data.inventory);
            }

            self.item.unitPrice = data.inventory.unitPrice;
            self.item.unitPriceFloat = data.inventory.unitPriceFloat;
            self.item.pricePerWeight = data.inventory.pricePerWeight;
            self.item.pricePerWeightFloat = data.inventory.pricePerWeightFloat;
            self.item.value = data.inventory.value;

            self.$data.primeCostForm = false;
          } else {
            showDialog(data.message);
          }
        })
        .catch(function(err) {
          let msg = err;
          if(err.response !== undefined) {
            msg += ' (' + err.response + ')';
          }
          showDialog(msg, "ERROR");
        })
    },
    openPriceForm: function() {
      this.$data.priceForm = {
        id: this.item.id,
        priceFloat: 0.00,
        sellingPrice: 0,
      }
    },
    onPriceFormChanged: function() {
      if(this.$data.priceForm.priceFloat === null || this.$data.priceForm.priceFloat === '') {
        this.$data.priceForm.sellingPrice = 0;
      } else {
        this.$data.priceForm.sellingPrice = Math.round(parseFloat(this.$data.priceForm.priceFloat) * 100);
      }
      console.log("price now is " + this.$data.priceForm.sellingPrice + " unit price =" + this.item.unitPrice);
      // if(this.$data.priceForm.sellingPrice <= this.item.unitPrice) {
      //   showDialog("New price is lower than purchasing price", "ERROR");
      //
      // }
    },
    closePriceForm: function() {
      this.$data.priceForm = false;
    },
    submitPriceForm: function() {

      if(this.$data.priceForm.priceFloat === null || this.$data.priceForm.priceFloat === '') {
        showDialog("Please enter selling price");
        return;
      }
      this.$data.priceForm.sellingPrice = Math.round(parseFloat(this.$data.priceForm.priceFloat)*100);
      // if(this.$data.priceForm.sellingPrice <= this.item.unitPrice) {
      //   showDialog("New price is lower than purchasing price", "ERROR");
      //   return;
      // }

      let self = this;
      changeInventorySellingPrice(this.$data.priceForm)
        .then(function(data) {
          if(data.success) {
            if(self.onUpdated !== null) {
              self.onUpdated(data.inventory);
            }

            self.item.sellingPrice = data.inventory.sellingPrice;
            self.item.sellingPriceFloat = data.inventory.sellingPriceFloat;

            self.$data.priceForm = false;
          } else {
            showDialog(data.message);
          }
        })
        .catch(function(err) {
          let msg = err;
          if(err.response !== undefined) {
            msg += ' (' + err.response + ')';
          }
          showDialog(msg, "ERROR");
        })
    },
    openMoveForm: function() {
      this.$data.moveForm = {
        sourceId: this.item.id,
        area:'',
        location:'',
        section:'',
        newBalance:0,
        newWeight:0,
        newWeightFloat:0.00,
        timeDiff:0,
      }
    },
    closeMoveForm: function() {
      this.$data.moveForm = false;
    },
    submitMoveForm: function() {
      if(this.$data.moveForm.area === '' || this.$data.moveForm.location === '' || this.$data.moveForm.section === '') {
        showDialog("Please select location");
        return;
      }
      if(this.product.useVariablePrice === true) {
        if(this.$data.moveForm.newWeightFloat === null || this.$data.moveForm.newWeightFloat.length === 0) {
          showDialog("Please enter the weight to move");
          return;
        }
        this.$data.moveForm.newWeight = Math.round(parseFloat(this.$data.moveForm.newWeightFloat) * 100);
        if(this.$data.moveForm.newWeight <= 0) {
          showDialog("The weight to move should be greater than 0");
          return;
        }
        if(this.$data.moveForm.newWeight >= this.item.weightBalance) {
          showDialog("The weight to move should be less than " + this.item.weightBalance + "kg");
          return;
        }

      } else {
        if (this.$data.moveForm.newBalance === 0) {
          showDialog("Please select quantity to move");
          return;
        }

        if (this.$data.moveForm.newBalance >= this.item.balance) {
          showDialog("Quantity to move should be less than current stock balance " + this.item.balance);
        }
      }

      let self = this;
      moveInventoryInventory(this.$data.moveForm)
        .then(function(data){
          if(data.success === true) {
            if(data.inventories !== undefined && data.inventories !== null) {
              for(let i = 0 ; i < data.inventories.length ; i++) {
                if(self.onUpdated !== null) {
                  self.onUpdated(data.inventories[i]);
                }
              }
            }
            self.$data.moveForm = false;
          } else {
            showDialog(data.message, "Failed to move");
          }
        })
        .catch(function(err) {
          let msg = err;
          if(err.response !== undefined) {
            msg += ' (' + err.response + ')';
          }
          showDialog(msg, "ERROR at moving inventory");
        })

    },
    openOutForm: function() {
      console.log("Out form ");
      console.log(this.product);
      this.$data.outForm = {
        stock: getNewStock(this.product.id, '', this.product),
      }
      this.$data.outForm.stock.inventoryId = this.item.id;
    },
    closeOutForm: function() {
      this.$data.outForm = false;
    },
    fileBtn:function(e) {
      // e.preventDefault();
      const uploader = document.getElementById('uploader');
      //get file
      console.log("File Btn Added");
      console.log(e);
      let getFile = e.target.files[0];
      console.log("File name - " + getFile.name);
      //set storage ref
      let d = new Date();
      let name = moment(d).format('YYYYMMDD-hhmmss');
      let names = getFile.name.split('.');
      let path = 'stock/out/' + getFilePathFromTodayDate() + '/' + name + '.' + names[names.length-1];
      let storageRef = firebase.storage().ref();
      let mountainsRef = storageRef.child(path);
      let self = this;
      mountainsRef.put(getFile).on('state_changed',
        function progress(snapshot){

          let percentage = (snapshot.bytesTransferred / snapshot.totalBytes) *100;
          console.log("percentage " + percentage);
          uploader.value = percentage;
        },
        function error(err){
          console.log(err);
        },
        function complete(){
          console.log('complete upload https://storage.googleapis.com/kokoro-294123.appspot.com/' + path);
          self.$data.outForm.stock.documents.push('https://storage.googleapis.com/kokoro-294123.appspot.com/' + path);
          console.log(self.$data.outForm.stock.documents);
        }
      );
    },
    submitOutForm: function() {
      if(this.$data.outForm.stock.type === null || this.$data.outForm.stock.type === '') {
        showDialog("Please select type");
        return;
      }

      if(this.product.useVariablePrice === true) {

        if(this.$data.outForm.stock.diffWeightFloat === null || this.$data.outForm.stock.diffWeightFloat.length === 0) {
          showDialog("Please enter weight to stock out");
          return;
        }
        this.$data.outForm.stock.diffWeight = Math.round(parseFloat(this.$data.outForm.stock.diffWeightFloat) * 100);
        if(this.$data.outForm.stock.diffWeight <= 0) {
          showDialog("Weight to stock out should be greater than 0")
          return;
        }
      } else {
        if(this.$data.outForm.stock.diff === null || this.$data.outForm.stock.diff.length === 0) {
          showDialog("Please enter quantity to stock out");
          return;
        }
        this.$data.outForm.stock.diff =parseInt(this.$data.outForm.stock.diff);
        if(this.$data.outForm.stock.diff <= 0) {
          showDialog("The quantity should be greater than 0");
          return;
        }

      }
      let self = this;
      console.log("submit out");
      console.log(this.$data.outForm.stock);
      stockOutFromInventory(this.$data.outForm.stock)
        .then(function(data) {
          if(data.success === true) {
            if(data.inventory !== null) {
              self.item.balance = data.inventory.balance;
            }
            if(data.stock !== null) {
              let found = false;
              for(let i = 0 ; i > self.$data.stocks.length ; i++) {
                if(self.$data.stocks[i].id === data.stock.id) {
                  self.$data.stocks.splice(i, 1, data.stock);
                  found = true;
                  break;
                }
              }
              if(found === false) {
                self.$data.stocks.unshift(data.stock);
              }


            }
            if(data.product !== undefined && data.product !== null) {
              if(self.onProductUpdated !== null) {
                self.onProductUpdated(data.product);
              }
            }
            self.outForm = false;
          } else {
            showDialog(data.message);
          }
        })
        .catch(function(err) {
          let msg = err;
          if(err.response !== undefined) {
            msg += ' (' + err.response + ')';
          }
          showDialog(msg);
        })

    },
    activate: function() {
      let msg = "Are you sure to ACTIVATE this inventory?";
      let self = this;
      this.$data.selectorView = {
        title: "Actovate inventory",
        message:msg,
        negativeButton: {
          title: 'No',
          onClicked: function(){self.$data.selectorView = false}
        },
        positiveButton: {
          title: 'Yes Activate',
          onClicked: this.activateConfirmed
        }
      }
    },
    activateConfirmed: function() {
      this.$data.selectorView = false;
      let self = this;
      deactivateInventory(this.item.id, true)
        .then(function(data) {
          if(data.success === true) {
            if(self.onUpdated !== null) {
              self.onUpdated(data.inventory);
            }
            if(self.onReorder !== null) {
              self.onReorder();
            }
            if(self.onClose !== null) {
              self.onClose();
            }
          }
        })
        .catch(function(err) {
          let msg = err;
          console.log(err);
          if(err.response !== undefined) {
            msg += '(' + err.response + ')';
          }
          showDialog(msg, "ERROR");
        })

    },
    deactivate: function() {
      let msg = "Are you sure to deactivate this inventory?<br/>If yes, currently picked items will be moved to other available inventories.";
      let self = this;
      this.$data.selectorView = {
        title: "Stop using this inventory",
        message:msg,
        negativeButton: {
          title: 'No',
          onClicked: function(){self.$data.selectorView = false}
        },
        positiveButton: {
          title: 'Yes deactivate',
          onClicked: this.deactivateConfirmed
        }
      }

    },
    deactivateConfirmed: function() {
      this.$data.selectorView = false;
      let self = this;
      deactivateInventory(this.item.id, false)
        .then(function(data) {
          if(data.success === true) {
            if(self.onUpdated !== null) {
              self.onUpdated(data.inventory);
            }
            if(self.onClose !== null) {
              self.onClose();
            }
          }
        })

    },

    openCorrectionForm: function() {
      this.$data.correctionForm = {
        id: this.item.id,
        currentBalance: this.item.balance,
        newBalance: this.item.balance,
        currentWeight: this.item.weightBalance,
        newWeightFloat: this.item.weightBalanceFloat,
        newWeight:0,
        description:'',
      };
    },
    closeCorrectionForm: function() {
      this.$data.correctionForm = false;
    },
    submitCorrection: function() {

      let self = this;
      let form = {
        id: this.$data.correctionForm.id,
        newBalance: this.$data.correctionForm.newBalance,
        description: this.$data.correctionForm.description,
        newWeight:0,
      };
      if(this.product.useVariablePrice === true) {
        if(this.$data.correctionForm.newWeightFloat === null || this.$data.correctionForm.newWeightFloat === '') {
          showDialog("Please enter new weight");
          return;
        }
        form.newWeight = Math.round(parseFloat(this.$data.correctionForm.newWeightFloat)*100);
      }
      correctInventory(form)
        .then(function(data) {
          if(data.success === true) {
            if(data.inventory !== null) {
              self.item.balance = data.inventory.balance;
            }
            if(data.stock !== null) {
              let found = false;
              for(let i = 0 ; i > self.$data.stocks.length ; i++) {
                if(self.$data.stocks[i].id === data.stock.id) {
                  self.$data.stocks.splice(i, 1, data.stock);
                  found = true;
                  break;
                }
              }
              if(found === false) {
                self.$data.stocks.push(data.stock);
              }


            }
            if(data.product !== undefined && data.product !== null) {
              if(self.onProductUpdated !== null) {
                self.onProductUpdated(data.product);
              }
            }
            self.$data.correctionForm = false;
          }
        })
        .catch(function(err) {
          let msg = err;
          if(err.response !== undefined) {
            msg += ' (' + err.response + ')';
          }

          showDialog(msg, "ERROR at correcting");
        })

    }
  },


}
</script>

<style scoped>
.inventory-header {
  height: 70px;
  width: 100%;
  line-height: 70px;
  font-weight: bold;
  font-size: 30px;
  border-bottom: 2px solid #ccc;
}
.inventory-body {
  width: 100%;
  height: calc(100% - 70px);
  display: flex;
}
.inventory-body > div {

  height: 100%;

}
.inventory-item-container {
  margin: 10px;
  border-radius: 10px;
  background: white;
  border: 1px solid #ccc;

}
.inventory-large {
  font-size: 50px;
  font-weight: bold;

}
.inventory-medium {
  font-size: 30px;
  font-weight: bold;
}
.clickable:hover {
  color: #36A9E1;
}
.inventory-small {
  font-size: 20px;
  font-weight: bold;
}
.selector-btn {
  width: 100%;
  padding: 20px;
  border: 1px solid #ccc;
  font-size: 15px;
}
.selector-btn.selected {
  background: blue;
  color: white;
  font-weight: bold;
}

.image-list-container {
  height: 200px;

  //display: flex;
  white-space: nowrap;

  margin-bottom: 10px;
  overflow-x: scroll;
}
.image-list-container .image-item{

  height: 200px;
  width:200px;
  display: inline-block;
  margin-left: 10px;

}
.image-item {
  background-size: contain;
  background-repeat: no-repeat;
  background-position: center;
  position: relative;

  background-color: gray;
}
.image-list-container .image-control {
  height: 200px;
  width: 300px;
  margin-left: 10px;
  border-radius: 10px;

  //border:1px solid gray;
}
.image-control progress {
  width: 90%;
  height: 30px;
  margin-top:30px;
}
.image-control input {
  width: 90%;
}

.top-left-icon {
  position: absolute;
  top: 10px;
  right:10px;
  color: red;
  background-color: white;
  padding:10px;
  box-shadow: 5px 5px 5px gray;
  border-radius: 50%;

}
</style>



// WEBPACK FOOTER //
// src/components/ItemView/InventoryItemView.vue